import { CSSProperties, PropsWithChildren } from "react";

type PropsType = {
    className?: string;
    style?: CSSProperties;
};

function Paper(props: PropsWithChildren<PropsType>) {
    return (
        <div className={`paper ${props.className ?? ""}`} style={props.style}>
            {props.children}
        </div>
    );
}

export default Paper;
